import { Apresentacao } from "./style";
import BarSVG from "../../../../assets/bar.svg"
import Womanswebp from "../../../../assets/womans.webp"
import { HiArrowDown } from "react-icons/hi"

function ApresentacaoComponent() {
    
    return (
        <Apresentacao>
            <div>
                <span id="seLiga">Se liga só!  👋🏼</span>
                <h1>Você já <span>[des]</span>aprendeu inglês por muito tempo.</h1>
                <p>Vou remover a venda que cobre seus olhos e fazer você se comunicar em inglês em <span>8 meses</span>.</p>
                <button><a href="#perguntas">Conheça meu trabalho <HiArrowDown id="icon"/></a></button>
                <img src={BarSVG} alt="" />
            </div>
            <figure>
                <img src={Womanswebp} alt="" />
            </figure>
        </Apresentacao>
    )
}

export default ApresentacaoComponent;